import React, { useEffect, useRef, useState } from "react";
import ChatInterface from "./ChatInterface";
import ChatHeader from "./ChatHeader";
import AIChatSidebar from "./AiChatSidebar";
import AiChatSidebarRight from "./AiChatSidebarRight";
import { useNavigate, useParams } from "react-router-dom";
import { getLastWordsContext } from "../Functions/GetLastWords"
import SystemInstructionsSidebar from "./SysInstructionSidebar";
import { io } from "socket.io-client";
import WebPreview from "./WebPreview";
import AbilitiesModal from "./AbilitiesModal";
import ConnectOauthModal from "../MCPs/Oauth/ConnectOauthModal";
import ConnectCustomMcpModal from "../MCPs/CustomMcps/ConnectCustomMcpModal";
import DisconnectOatuhModal from "../MCPs/Oauth/DisconnectOauthModal";
import DisconnectCustomMcpModal from "../MCPs/CustomMcps/DisconnectCustomMcpModal";
import { useLanguage } from "../Translations/LenguageContext";
import PoolerSidebar from "./PoolerSidebar";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;
const GEN_AI_LINK = process.env.REACT_APP_GEN_AI_LINK
const REACT_APP_GEN_BACKEND_LINK_STREAMING = process.env.REACT_APP_GEN_BACKEND_LINK_STREAMING


const AIChatMain = ({
    account_id,
    userData,
    mcpData,
    fetchMcpData,
    loadingMcpData,
    setMcpData
}) => {
    const {t} = useLanguage()
    const scrollContainerRef = useRef(null)
    const inputRef = useRef(null);
    const chatEndRef = useRef(null);
    const socketRef = useRef(null);
    const userLastMessageRef = useRef(null)
    const navigate = useNavigate()
    const { org_id, chat_id } = useParams()
    const [openPoolerSidebar, setOpenPoolerSidebar] = useState(false)
    const [openSidebarRight, setOpenSidebarRight] = useState(false)
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const [chatId, setChatId] = useState(null);
    const [chatTitle, setChatTitle] = useState(null);
    const [input, setInput] = useState("");
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorAi, setErrorAi] = useState({ message: "", display: false })
    const abortControllerRef = useRef(null);
    const [loadingChatHistory, setLoadingChatHistory] = useState(false)
    const [files, setFiles] = useState([]);
    const [providerModel, setProviderModel] = useState("cerebras")
    const [openSystemInstruction, setOpenSystemInstruction] = useState(false)
    const [selectedSystemInstructions, setSelectedSystemInstructions] = useState(null)
    const [selectedSystemInstructionsId, setSelectedSystemInstructionsId] = useState({})
    const [activeAiMessageId, setActiveAiMessageId] = useState(null);
    const [activeUserMessageId, setActiveUserMessageId] = useState(null);
    const [steps, setSteps] = useState({})
    const [openWebPreview, setOpenWebPreview] = useState(false)
    const [selectedLink, setSelectedLink] = useState(null)
    const [openAbilitiesModal, setOpenAbilitiesModal] = useState(false)
    const [showConnectMcpModal, setShowConnectMcpModal] = useState(false)
    const [showDisconnectMcpModal, setShowDisconnectMcpModal] = useState(false)
    const [openCustomModal, setOpenCustomModal] = useState(false)
    const [showCustomDisconnectModal, setShowCustomDisconnectModal] = useState(false)
    const [selectedMCP, setSelectedMcp] = useState({});
    const [openErrDepModal, setOpenErrDepModal] = useState(false)
    const [liveStatusMessage, setLiveStatusMessage] = useState(null)
    const [offset, setOffset] = useState(0);
    const LIMIT = 10;
    const [hasMoreMessages, setHasMoreMessages] = useState(false);
    const [loadingOlderMessages, setLoadingOlderMessages] = useState(false);

    const [reasoning, setReasoning] = useState({
        reasoning_flow: [],
        search_metadata: null,
        reasoning_depth: ""
    });

    const [selectedModel, setSelectedModel] = useState(
        JSON.parse(localStorage.getItem("ai_selected_model")) || {
            id: "omni-t0-0101010101",
            name: "Omni-t0",
            description: "Developed by Type Zero Research",
            inference_provider: "Type Zero Research"
        }
    )

    const [selectedModelTitle, setSelectedModelTitle] = useState(
        localStorage.getItem("ai_selected_model_title") || "t0r/omni-t0"
    );

    const [temperature, setTemperature] = useState(
        parseFloat(localStorage.getItem("ai_temperature")) || 1
    );

    const [reasoningDepth, setReasoningDepth] = useState(
        localStorage.getItem("ai_reasoning_depth") || "off"
    );

    const [isMemoryEnabled, setIsMemoryEnabled] = useState(
        localStorage.getItem("ai_is_memory_enabled") === "false" ? false : true
    );

    const [isSearchEnabled, setIsSearchEnabled] = useState(
        localStorage.getItem("ai_is_search_enabled") === "false" ? false : true
    );

    const [isJsonMode, setIsJsonMode] = useState(
        localStorage.getItem("ai_is_json_mode") === "true" ? true : false
    );

    const [connectors, setConnectors] = useState([]);

    const toggleSidebar = () => {
        sidebarOpen ? setSidebarOpen(false) : setSidebarOpen(true)
    }

    const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    const handleInput = () => {
        const el = inputRef.current;
        if (!el) return;

        el.style.height = "auto";

        const maxHeight = 200;

        if (el.scrollHeight <= maxHeight) {
            el.style.overflowY = "hidden";
            el.style.height = el.scrollHeight + "px";
        } else {
            el.style.height = maxHeight + "px";
            el.style.overflowY = "auto";
        }
    };

    const handleSendMessage = async (e, messageIdToUpdate = null, overrideInput = null) => {
        if (e) e.preventDefault();
        setErrorAi({ message: "", display: false });
        setIsLoading(true);

        const currentInput = overrideInput ?? input;
        if (!currentInput.trim() || isLoading) return;

        setInput("");
        setFiles([])
        setSteps({})

        if (inputRef?.current) {
            inputRef.current.style.height = "auto";
            inputRef.current.style.overflowY = "hidden";
        }

        const lastContext = getLastWordsContext(messages, 1000);

        const userMessageId = Date.now()
        const userMessage = {
            id: userMessageId,
            sender: "user",
            text: currentInput,
            files: files,
            timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        };

        const aiMessageId = Date.now() + 1;
        const aiPlaceholder = {
            id: aiMessageId,
            sender: "ai",
            model_used: selectedModelTitle,
            text: "",
            reasoning_depth: reasoningDepth,
            generated_files: [],
            live_message: "",
            timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        };

        setActiveAiMessageId(aiMessageId);
        setMessages((prev) => [...prev, userMessage, aiPlaceholder]);

        abortControllerRef.current = new AbortController();

        const formData = new FormData();

        formData.append("message_id_to_update", messageIdToUpdate);
        formData.append("account_id", account_id);
        formData.append("org_id", org_id);
        formData.append("chat_id", chat_id);
        formData.append("chat_title", chatTitle || "");
        formData.append("model", selectedModelTitle);
        formData.append("inference_provider", providerModel);
        formData.append("temperature", temperature);
        formData.append("reasoning_depth", reasoningDepth);
        formData.append("search_enabled", isSearchEnabled);
        formData.append("memory", isMemoryEnabled);
        formData.append("json_enabled", isJsonMode);
        formData.append("prompt", currentInput);
        formData.append("last_prompts", JSON.stringify(lastContext));
        formData.append("connectors", JSON.stringify(connectors));
        formData.append("system_instructions", JSON.stringify(selectedSystemInstructions) || "");
        formData.append("type", org_id);

        files.forEach((file, index) => {
            formData.append("files", file);
        });

        try {
            const response = await fetch(`${GEN_AI_LINK}/simple_chat`, {
                method: "POST",
                signal: abortControllerRef.current.signal,
                body: formData,
            });

            if (!response.ok) throw new Error("Failed to connect to AI");

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let accumulatedText = "";

            while (true) {
                const { value, done } = await reader.read();
                if (done) break;

                const chunk = decoder.decode(value);
                const lines = chunk.split("\n");

                for (const line of lines) {
                    if (!line.startsWith("data: ")) continue;

                    try {
                        const data = JSON.parse(line.replace("data: ", ""));

                        if (data.type === "setup") {
                            setChatId(data.chat_id);
                            setChatTitle(data.chat_title);
                            navigate(`/e8console/organizations/${org_id}/playground/${data.chat_id}`)
                        }

                        else if (data.type === "search_results") {
                            setMessages((prev) => prev.map((msg) =>
                                msg.id === aiMessageId ? { ...msg, search_metadata: data.data } : msg
                            ));
                        }
                        else if (data.type === "reasoning") {
                            setMessages((prev) => prev.map((msg) =>
                                msg.id === aiMessageId ? { ...msg, reasoning_flow: data.steps } : msg
                            ));
                        }
                        else if (data.type === "token") {
                            const model_back = data.model
                            accumulatedText += data.text;
                            setMessages((prev) => prev.map((msg) =>
                                msg.id === aiMessageId ? { ...msg, text: accumulatedText } : msg
                            ));
                            setMessages((prev) => prev.map((msg) =>
                                msg.id === aiMessageId ? { ...msg, model_used: model_back } : msg
                            ));
                        }
                        else if (data.type === "generation") {
                            const generation_result = data.result
                            const generated_files = generation_result.saved_files
                            setMessages((prev) => prev.map((msg) =>
                                msg.id === aiMessageId ? { ...msg, generated_files: generated_files } : msg
                            ));
                        }
                        else if (data.type === "saved_file") {
                            const saving_result = data.result
                            setMessages((prev) => prev.map((msg) =>
                                msg.id === userMessageId ? { ...msg, files: saving_result } : msg
                            ));
                        }
                        else if (data.type === "live_status") {
                            const live_message = data.live_message
                            setMessages((prev) => prev.map((msg) =>
                                msg.id === aiMessageId ? { ...msg, live_message: live_message } : msg
                            ));
                        }
                        else if (data.type === "error") {
                            throw new Error(data.msg);
                        }
                    } catch (e) {
                        console.error("Error parsing stream chunk", e);
                    }
                }
            }
            setIsLoading(false);
            abortControllerRef.current = null;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log("Stream aborted");
            } else {
                setIsLoading(false);
                console.error("Error sending message:", error);
                setErrorAi({ message: t.playground.error_gen, display: true });
            }
        }
    };

    const handleStopMessage = async () => {
        if (abortControllerRef.current) abortControllerRef.current.abort();
        setIsLoading(false);

        if (chatId) {
            try {
                await fetch(`${GEN_AI_LINK}/stop_chat`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ account_id, chat_id: chatId }),
                });
            } catch (err) {
                console.error("Failed to stop AI chat:", err);
            }
        }
    };

    const fetchChatMessages = async (
        isInitial = false,
        customOffset = offset
    ) => {
        if (isInitial) {
            setLoadingChatHistory(true);
        } else {
            setLoadingOlderMessages(true);
        }

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_single_chat`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    chat_id,
                    limit: LIMIT,
                    offset: customOffset
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch chat history");
            }

            const chatData = result.data;

            const mappedMessages = chatData.messages.map(msg => ({
                id: msg.id || Date.now() + Math.random(),
                sender: msg.message?.role === "user" ? "user" : "ai",
                text: msg.message?.content || "",
                timestamp: new Date(msg.created_at).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                }),
                model_used: msg.config?.model || selectedModelTitle,
                reasoning_flow: msg.reasoning?.steps || [],
                reasoning_depth: msg.config?.reasoning_depth || [],
                live_message: msg?.message?.live_message || "",
                search_metadata: msg.search_results || null,
                files: msg.message?.files || [],
                generated_files: msg.message?.generated_files || []
            }));

            console.log(chatData)
            setMessages(prev => {
                const existingIds = new Set(prev.map(m => m.id));

                const uniqueMessages = mappedMessages.filter(
                    m => !existingIds.has(m.id)
                );

                return [...uniqueMessages, ...prev];
            });

            setHasMoreMessages(chatData.has_more);

            const nextOffset = customOffset + LIMIT;
            setOffset(nextOffset);

        } catch (err) {
            console.error(err);
        } finally {
            setTimeout(() => {
                setLoadingOlderMessages(false);
            }, 2000);
            setLoadingChatHistory(false);
        }
    };

    const MAX_FILES = 20;
    const addFiles = (newFiles) => {
        const fileArray = Array.from(newFiles);

        setFiles((prev) => {
            const combined = [...prev, ...fileArray];

            if (combined.length > MAX_FILES) {

                return prev;
            } else {

            }

            return combined;
        });
    };

    const streamSteps = (chatId) => {
        setSteps({})
        if (!chatId) return;
        if (socketRef.current) {
            socketRef.current.disconnect();
            socketRef.current = null;
        }

        const socket = io(REACT_APP_GEN_BACKEND_LINK_STREAMING, {
            transports: ["websocket"],
        });

        socketRef.current = socket;

        const id_to_send = `${chatId}-${account_id}`
        socket.on("connect", () => {
            socket.emit("subscribe_steps", {
                chatId: id_to_send,
                isAutotestEnabled: false
            });
        });

        socket.on("steps", (data) => {
            if (data?.steps != "NOT_FOUND") {
                setSteps(data?.steps)
            }
        });

        socket.on("connect_error", (err) => {
            console.error("Socket connection error:", err);
        });

        socket.on("disconnect_steps", () => {
            console.log("Socket disconnected");
        });
    };

    const handleFileInput = (e) => {
        addFiles(e.target.files);
        e.target.value = null;
    };

    const removeFile = (indexToRemove) => {
        setFiles(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    const handleOpenConnect = (system_provider) => {
        system_provider != "Project E8" ? setShowConnectMcpModal(true) : setOpenCustomModal(true)
    }

    const handleOpenDisconnect = (system_provider) => {
        system_provider != "Project E8" ? setShowDisconnectMcpModal(true) : setShowCustomDisconnectModal(true)
    }

    // useEffect(() => {
    //     // if (chatEndRef?.current) {
    //     //     chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    //     // }
    //     // if(userLastMessageRef?.current){
    //     //     userLastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    //     // }
    //     streamSteps(chatId)
    // }, [messages, userLastMessageRef]);

    const loadOlderMessages = async () => {
        if (loadingOlderMessages || !hasMoreMessages) return;

        const container = scrollContainerRef.current;

        if (!container) return;

        const previousHeight = container.scrollHeight;

        await fetchChatMessages(false, offset);

        requestAnimationFrame(() => {
            const newHeight = container.scrollHeight;

            container.scrollTop =
                newHeight - previousHeight;
        });
    };

    // const handleChatScroll = () => {
    //     const container = scrollContainerRef.current;

    //     if (!container) return;

    //     if (container.scrollTop < 100) {
    //         loadOlderMessages();
    //     }
    // };

    useEffect(() => {
        if (chat_id != "new-chat") {
            fetchChatMessages(true, 0);
        }
    }, [account_id]);;

    return (
        <div className="main_playground_cont">
            <div className={`ai_chat_content ${sidebarOpen ? "" : "ai_chat_content_open"}`}>
                <ChatHeader chatTitle={chatTitle} toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
                <ChatInterface
                    account_id={account_id}
                    chatEndRef={chatEndRef}
                    userLastMessageRef={userLastMessageRef}
                    account_id={account_id}
                    handleSendMessage={handleSendMessage}
                    handleStopMessage={handleStopMessage}
                    timestamp={timestamp}
                    chatId={chatId}
                    messages={messages}
                    isLoading={isLoading}
                    errorAi={errorAi}
                    input={input}
                    setInput={setInput}
                    selectedModel={selectedModelTitle}
                    temperature={temperature}
                    reasoningDepth={reasoningDepth}
                    isMemoryEnabled={isMemoryEnabled}
                    setIsMemoryEnabled={setIsMemoryEnabled}
                    isSearchEnabled={isSearchEnabled}
                    isJsonMode={isJsonMode}
                    connectors={connectors}
                    reasoning={reasoning}
                    loadingChatHistory={loadingChatHistory}
                    setIsSearchEnabled={setIsSearchEnabled}
                    setIsJsonMode={setIsJsonMode}
                    setConnectors={setConnectors}
                    loadingMcpData={loadingMcpData}
                    mcpData={mcpData}
                    files={files}
                    setFiles={setFiles}
                    handleFileInput={handleFileInput}
                    handleInput={handleInput}
                    removeFile={removeFile}
                    inputRef={inputRef}
                    selectedSystemInstructions={selectedSystemInstructions}
                    steps={steps}
                    activeAiMessageId={activeAiMessageId}

                    openWebPreview={openWebPreview}
                    setOpenWebPreview={setOpenWebPreview}
                    selectedLink={selectedLink}
                    setSelectedLink={setSelectedLink}
                    setOpenAbilitiesModal={setOpenAbilitiesModal}

                    scrollContainerRef={scrollContainerRef}
                    loadOlderMessages={loadOlderMessages}
                    loadingOlderMessages={loadingOlderMessages}
                    hasMoreMessages={hasMoreMessages}
                />
            </div>
            <AIChatSidebar
                account_id={account_id}
                selectedModelTitle={selectedModelTitle}
                selectedModel={selectedModel}
                setTemperature={setTemperature}
                temperature={temperature}
                toggleSidebar={toggleSidebar}
                sidebarOpen={sidebarOpen}
                reasoningDepth={reasoningDepth}
                setReasoningDepth={setReasoningDepth}
                isSearchEnabled={isSearchEnabled}
                setIsSearchEnabled={setIsSearchEnabled}
                isMemoryEnabled={isMemoryEnabled}
                setIsMemoryEnabled={setIsMemoryEnabled}
                isJsonMode={isJsonMode}
                setIsJsonMode={setIsJsonMode}
                setOpenSidebarRight={setOpenSidebarRight}
                setOpenPoolerSidebar={setOpenPoolerSidebar}
                mcpData={mcpData}
                connectors={connectors}
                setConnectors={setConnectors}
                fetchMcpData={fetchMcpData}
                loadingMcpData={loadingMcpData}
                setOpenSystemInstruction={setOpenSystemInstruction}
                selectedSystemInstructions={selectedSystemInstructions}
                setOpenAbilitiesModal={setOpenAbilitiesModal}

            />

            <PoolerSidebar
                show={openPoolerSidebar}
                handleClose={() => setOpenPoolerSidebar(false)}
            />

            <AiChatSidebarRight
                show={openSidebarRight}
                handleClose={() => setOpenSidebarRight(false)}
                setSelectedModelTitle={setSelectedModelTitle}
                selectedModelTitle={selectedModelTitle}
                setSelectedModel={setSelectedModel}
                selectedModel={selectedModel}
                setProviderModel={setProviderModel}
            />

            <SystemInstructionsSidebar
                account_id={account_id}
                show={openSystemInstruction}
                handleClose={() => setOpenSystemInstruction(false)}
                selectedSystemInstructionsId={selectedSystemInstructionsId}
                setSelectedSystemInstructionsId={setSelectedSystemInstructionsId}
                setSelectedSystemInstructions={setSelectedSystemInstructions}
            />

            <WebPreview
                show={openWebPreview}
                handleClose={() => setOpenWebPreview(false)}
                selectedLink={selectedLink}
                setSelectedLink={setSelectedLink}
            />

            <AbilitiesModal
                account_id={account_id}
                show={openAbilitiesModal}
                handleClose={() => setOpenAbilitiesModal(false)}
                mcpData={mcpData}
                fetchMcpData={fetchMcpData}
                loadingMcpData={loadingMcpData}
                connectors={connectors}
                setConnectors={setConnectors}
                handleOpenConnect={handleOpenConnect}
                handleOpenDisconnect={handleOpenDisconnect}
                setSelectedMcp={setSelectedMcp}
                setOpenErrDepModal={setOpenErrDepModal}
            />

            <ConnectOauthModal
                account_id={account_id}
                userData={userData}
                show={showConnectMcpModal}
                handleClose={() => setShowConnectMcpModal(false)}
                selectedMCP={selectedMCP}
                setMcpData={setMcpData}
            />

            <ConnectCustomMcpModal
                account_id={account_id}
                userData={userData}
                show={openCustomModal}
                handleClose={() => setOpenCustomModal(false)}
                selectedMCP={selectedMCP}
                fetchData={fetchMcpData}
                setMcpData={setMcpData}
            />

            <DisconnectOatuhModal
                account_id={account_id}
                userData={userData}
                show={showDisconnectMcpModal}
                handleClose={() => setShowDisconnectMcpModal(false)}
                selectedMCP={selectedMCP}
                fetchData={fetchMcpData}
            />

            <DisconnectCustomMcpModal
                account_id={account_id}
                userData={userData}
                show={showCustomDisconnectModal}
                handleClose={() => setShowCustomDisconnectModal(false)}
                selectedMCP={selectedMCP}
                fetchData={fetchMcpData}
            />

        </div>
    );
};

export default AIChatMain;